import { Dayjs } from "dayjs";

import { CaseStatus } from "@/api/rest/models/warranty";

export interface Question {
  id: number;
  householdId: number;
  title: string;
  status: CaseStatus;
  createdAt: string;
  lastMessageTimestamp?: string;
  createdAtTimestamp: Dayjs;
  localisedStatus: string;
  needsBuilderReply?: boolean;
}

export interface QuestionRaw {
  id: number;
  householdId: number;
  title: string;
  status: CaseStatus;
  createdAt: string;
  lastMessageTimestamp?: string;
  needsBuilderReply?: boolean;
}

export interface QuestionMessage {
  id: number;
  questionId: number;
  accountId: number;
  userId: number;
  createdAt: string;
  content: string;
  type: QuestionMessageType;
  deletedAt?: string;
  createdAtTimestamp: Dayjs;
  userName: string;
  mimeType?: string | null;
}

export interface QuestionMessageRaw {
  id: number;
  questionId: number;
  accountId: number;
  userId: number;
  createdAt: string;
  content: string;
  type: QuestionMessageType;
  deletedAt?: string;
  userName: string;
  mimeType?: string | null;
}

export enum QuestionMessageType {
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  FILE = "FILE",
  AI_HISTORY = "AI_HISTORY",
}

export interface QuestionResponse {
  question: Question;
  messages: QuestionMessage[];
}

export const questionStatusMap = new Map<CaseStatus, string>([
  [CaseStatus.BACKLOG, "question.status.backlog"],
  [CaseStatus.SOLVED, "question.status.solved"],
  [CaseStatus.CLOSED, "question.status.closed"],
]);

export interface AddQuestionMessageRequest {
  message: string;
  accountId: number;
}

export interface UpdateQuestionStatusRequest {
  buildingId: number;
  status: CaseStatus;
}
